import React, { useState, useEffect, useMemo } from 'react';
import GlassButton from '../components/ui/Button';
import GlassCard from '../components/ui/Card';
import InputField from '../components/ui/InputField';
import CustomSelect from '../components/ui/Select';
import useData from '../hooks/useData';

const ProjectForm = ({ projectToEdit, onSave, onCancel }) => {
    const { clients } = useData();
    const [projectData, setProjectData] = useState({
      name: '',
      description: '',
      clientId: ''
    });

    const clientOptions = useMemo(() => clients.map(c => ({ value: c.id, label: c.name })), [clients]);

    useEffect(() => {
        if (projectToEdit) {
            setProjectData({
                ...projectToEdit,
                clientId: projectToEdit.clientId || ''
            });
        } else {
            setProjectData({ name: '', description: '', clientId: '' });
        }
    }, [projectToEdit]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      setProjectData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      onSave(projectData);
    };

    return (
        <div className="space-y-4">
            <h2 className="text-3xl font-bold text-white mb-4">
                {projectToEdit ? 'Editar Projeto' : 'Cadastrar Novo Projeto'}
            </h2>
            <GlassCard className="p-4 md:p-8">
                <form onSubmit={handleSubmit} className="space-y-6 text-white">
                    <InputField
                        label="Nome do Projeto"
                        name="name"
                        value={projectData.name}
                        onChange={handleChange}
                        required
                        autoFocus
                    />
                    {/* --- INÍCIO DA ALTERAÇÃO: Dropdown para selecionar cliente --- */}
                    <CustomSelect
                        label="Associar Cliente (opcional)"
                        options={clientOptions}
                        value={projectData.clientId}
                        onChange={(e) => handleChange({ target: { name: 'clientId', value: e.target.value }})}
                        placeholder="Selecione um cliente..."
                    />
                    {/* --- FIM DA ALTERAÇÃO --- */}
                    <div>
                        <label className="block text-sm font-medium mb-1">Descrição (opcional)</label>
                        <textarea
                            name="description"
                            value={projectData.description}
                            onChange={handleChange}
                            rows="4"
                            className="w-full p-3 text-white bg-white/10 rounded-lg border border-white/30 focus:outline-none focus:ring-2 focus:ring-indigo-400/80 transition-all duration-200"
                        />
                    </div>
                    <div className="flex justify-end space-x-2 pt-4">
                        <GlassButton type="button" onClick={onCancel} variant="minimal">
                            Cancelar
                        </GlassButton>
                        <GlassButton type="submit">
                            {projectToEdit ? 'Salvar Alterações' : 'Cadastrar Projeto'}
                        </GlassButton>
                    </div>
                </form>
            </GlassCard>
        </div>
    );
};

export default ProjectForm;